import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const AudioSilenceAlert = () => {
    const [isVisible, setIsVisible] = useState(false);
    const { i18n } = useTranslation();
    const isRTL = i18n.language === 'he' || i18n.language === 'ar'

    useEffect(() => {
        const handleAlert = () => {
            console.log('[AudioSilenceAlert] Received audio-silence-alert event');
            setIsVisible(true);
        };

        const handleClear = () => {
            console.log('[AudioSilenceAlert] Received audio-silence-cleared event');
            setIsVisible(false);
        };

        window.addEventListener('audio-silence-alert', handleAlert);
        window.addEventListener('audio-silence-cleared', handleClear);

        return () => {
            window.removeEventListener('audio-silence-alert', handleAlert);
            window.removeEventListener('audio-silence-cleared', handleClear);
        };
    }, []);

    if (!isVisible) {
        return null;
    }

    return (
        <div className="fixed top-4 left-4 z-[9999] w-auto max-w-sm shadow-xl animate-fade-in-down" dir="rtl">
            <div className="bg-white rounded-xl p-4 flex flex-col gap-3 border border-red-100 shadow-sm relative overflow-hidden">
                {/* Accent bar */}
                <div className="absolute top-0 right-0 w-full h-1 bg-red-500"></div>

                <button
                    onClick={() => setIsVisible(false)}
                    className="absolute top-2 left-2 p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors z-10"
                    aria-label="סגור"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                <div className="flex items-start gap-3 mt-1">
                    <div className="bg-red-50 p-2 rounded-full shrink-0">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-red-500 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                            <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </div>
                    <div>
                        <h3 className="font-bold text-gray-900 text-lg leading-tight">לא מזוהה שיחה!</h3>
                        <p className="text-gray-600 text-sm mt-1 leading-snug">
                            לא מתקבל שמע ממך או מהלקוח כבר 10 שניות.
                        </p>
                    </div>
                </div>

                <div className="bg-gray-50 rounded-lg p-3 text-xs text-gray-600 w-full" dir={isRTL ? "ltr" : "rtl"}>
                    <p className="font-semibold text-gray-700 mb-1">נסה את הפעולות הבאות:</p>
                    <div className="flex flex-col gap-1 pr-1">
                        <div className="flex items-center gap-2">
                            <span className="w-1 h-1 bg-red-400 rounded-full"></span>
                            <span>בדוק אם המיקרופון מושתק</span>
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="w-1 h-1 bg-red-400 rounded-full"></span>
                            <span>וודא שנבחר התקן השמע הנכון</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
